import React, { useEffect, useState, useRef } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from 'src/store/reducers/state';
import { useSettingActions } from 'src/store/settings/actions';

const CreditActivityCreditTypesModal = () => {
    const dispatch = useDispatch();
    const ref = useRef<HTMLButtonElement>(null);
    const settingAction = useSettingActions(dispatch);
    const { creditActivityCreditTypes, isCreditActivityCreditTypesUpdated } = useSelector(
        (state: RootState) => {
            return {
                creditActivityCreditTypes: state.setting.creditActivityCreditTypes,
                isCreditActivityCreditTypesUpdated: state.setting.isCreditActivityCreditTypesUpdated
            };
        }
    );

    const {
        register: registerMapping,
        handleSubmit: handleSubmitMapping,
        reset: resetMapping,
        formState: { errors: mappingErrors }
    } = useForm();

    const onSubmitMapping = (data: any) => {
        settingAction.updateCreditActivityCreditTypesRequest({
            id: data.creditTypeId,
            mappingtext: data.mappingtext
        })
    };

    useEffect(() => {
        if (isCreditActivityCreditTypesUpdated) {
            resetMapping();
            if (ref.current) {
                ref.current.click();
            }
            handleCloseClick();
        }
    }, [isCreditActivityCreditTypesUpdated]);


    const handleCloseClick = () => {
        resetMapping({
            creditTypeId: '',
            mappingtext: ''
        });
    };
    return (
        <div
            className={`modal fade fixed top-0 left-0 hidden w-full h-full outline-none overflow-x-hidden overflow-y-auto modal-open`}
            id="creditActivityCreditTypesModal"
            aria-labelledby="creditActivityCreditTypesModalLabel"
            aria-hidden="true">
            <div className="modal-dialog relative w-auto pointer-events-none max-w-xl">
                <div className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
                    <div className="relative modal-header flex flex-shrink-0 items-center justify-between p-4 pb-2 rounded-t-md">
                        <h5
                            className="text-xl font-semibold leading-normal text-center w-full"
                            id="creditActivityCreditTypesModalLabel">
                            Credit Type Mapping
                        </h5>
                        <button
                            ref={ref}
                            onClick={handleCloseClick}
                            type="button"
                            className="dismiss-btn"
                            data-bs-dismiss="modal"
                            aria-label="Close"></button>
                    </div>
                    <div className="modal-body relative py-4 px-10">
                        <p className="text-sm text-gray-500 mb-5 leading-relaxed">
                            {`Map each Webcastcloud credit type to the corresponding Membes credit field (e.g. Points1, Points2). This mapping controls where CE credits are written back in Membes when course completions are processed.  If you're unsure which value to use, please contact Membes Support.`}
                        </p>

                        <form onSubmit={handleSubmitMapping(onSubmitMapping)}>

                            <div className="mb-4">
                                <label className="block mb-1">
                                    Credit Type <span className="text-red-500">*</span>
                                </label>
                                <select
                                    className="input-style"
                                    {...registerMapping('creditTypeId', { required: 'Please select a credit type' })}>
                                    <option value="">Select a credit type…</option>
                                    {creditActivityCreditTypes &&
                                        creditActivityCreditTypes.map((ct: any) => (
                                            <option key={ct.id} value={ct.id}>
                                                {ct.type}
                                            </option>
                                        ))}
                                </select>

                            </div>


                            <div className="mb-6">
                                <label className="block mb-1">
                                    Name Mapping
                                </label>
                                <input
                                    type="text"
                                    placeholder='e.g. Points1, Points2'
                                    className="input-style"
                                    {...registerMapping('mappingtext')}
                                />
                                <p className="text-xs text-gray-400 mt-1">
                                    {`This is the field name used in Membes to store the credit value (e.g. "Points1").`}
                                </p>
                            </div>


                            <div className="modal-footer flex flex-shrink-0 flex-wrap items-center justify-center p-4 rounded-b-md">
                                <button type="submit" className="px-6 btn-primary w-28 mr-2 ml-0 mt-0">
                                    Submit
                                </button>
                                <button
                                    onClick={handleCloseClick}
                                    type="button"
                                    className="mx-0 px-6 btn-primary discard-btn w-28 mt-0"
                                    data-bs-dismiss="modal">
                                    Cancel
                                </button>
                            </div>
                        </form>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default CreditActivityCreditTypesModal;
